import { Spinner } from '@/components/common/Spinner'

export const FullScreenLoader = () => <Spinner size="lg" fullScreen />
